<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap; margin-top: 10px;align-items: baseline;">
      <div class="search_list">
        <div class="text">产品链接组:</div>
        <Select v-model="groupId" @on-change="getData" class="select">
          <Option v-for="item in list" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <Button
        @click="
            upData = {state:1};
            title = '添加';
            Show = true;
          "
        style="margin-right: 15px"
        type="primary"
      >添加</Button>
    </div>
    <Table border class="table_style" :columns="columns" :data="userList" :highlight-row="true">
      <template slot-scope="{ row, index }" slot="state">
        <div v-if="row.state == 0">禁用</div>
        <div v-if="row.state == 1">正常</div>
      </template>

      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '修改';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >修改</Button>
        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >删除</Button>
      </template>
    </Table>
    <Modal width="1200" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '添加'||title == '修改'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>产品名称：</div>
          <div>
            <Input v-model="upData.productName" placeholder="产品名称" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>产品链接组:</div>
          <div>
            <Select v-model="upData.productUrlGroupId" @on-change="getData" class="select">
              <Option v-for="item in list" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>产品id：</div>
          <div>
            <Input v-model="upData.productId" placeholder="产品id" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>渠道编码：</div>
          <div>
            <Input v-model="upData.t3rdCode" placeholder="渠道编码" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>连接：</div>
          <div>
            <Input v-model="upData.url" placeholder="连接" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态:</div>
          <div>
            <Select v-model="upData.state">
              <Option :value="0">下架</Option>
              <Option :value="1">正常</Option>
            </Select>
          </div>
        </div>
      </div>
      <div v-if="title == '删除'">删除</div>
    </Modal>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      tCountStatistics: {},
      userList: [],
      userList1: { list: [] },
      list: [],
      title: "",
      upData: {},
      settleStatus: "",
      url: "",
      Show: false,
      groupId: "",
      parameter1: {
        pageNow: 1
      },
      columns: [
        {
          title: "产品id",
          className: "fontcolor",
          align: "center",
          key: "productId",
          width: 100
        },
        {
          title: "产品名称",
          className: "fontcolor",
          align: "center",
          key: "productName"
        },
        {
          title: "渠道编码",
          className: "fontcolor",
          align: "center",
          key: "t3rdCode"
        },
        {
          title: "地址",
          className: "fontcolor",
          align: "center",
          key: "url"
        },
        {
          title: "参数",
          className: "fontcolor",
          align: "center",
          key: "params"
        },
        {
          title: "状态",
          className: "fontcolor",
          align: "center",
          slot: "state"
        },
        {
          title: "创建时间",
          className: "fontcolor",
          align: "center",
          key: "createTime"
        },
        {
          title: "修改时间",
          className: "fontcolor",
          align: "center",
          key: "modifyTime"
        },

        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    UaorderShip() {
      if (this.title == "添加") {
        api.ProductUrlTmplAdd(this.upData).then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
      }
      if (this.title == "修改") {
        api.ProductUrlTmplEdit(this.upData).then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
      }
      if (this.title == "删除") {
        api.ProductUrlTmplDel(this.upData.id).then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
      }
    },
    getData() {
      api.ProductUrlGroupList().then(res => {
        this.list = res.body.data;
      });
      api.ProductUrlTmplList(this.groupId).then(res => {
        this.userList = res.body.data;
      });
    }
  }
};
</script>

<style scoped>
</style>